import React, { useState } from "react";
import PropTypes from "prop-types";
import { SketchPicker } from "react-color";
import { convertColor } from "../../../_utils/common";
import {
  DEFAULT_COLOR_PRESETS,
  HEX_COLOR_REGEX,
} from "../../details/constants";
import { StyledColorPickerIconButton } from "../../styled/details/stylesDetails";
import { StyledColorPickerPopover } from "../../styled/details/stylesTextPanel";
import EditableLabel from "../../common/EditableLabel";
import Format from "string-format";
import TldrBrandkitColors from "../../common/TldrBrandkitColors";
import {
  Box,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  Tooltip,
} from "@chakra-ui/react";
import EyeDropperContainer from "./EyeDropperContainer";
import { isEmpty } from "lodash";
import transparentBg from "../../../assets/icons/transparent.png";
import { connect } from "react-redux";

const menuButtonStyles = {
  borderRadius: "0 8px 8px 0",
  border: "none",
  height: "30px",
  width: "30px",
};

const defaultTransparent = 'rgba(255, 255, 255, 0)';

const TLDRColorPicker = (props) => {
  const {
    title,
    icon,
    color,
    action,
    callback,
    showIcon,
    showBrandkitPaletteColors,
    inputWidth,
    display,
    canvas,
    menuButtonExtraStyling,
    showColorInput = true,
    colorCode,
  } = props;

  const [isTransparent, setIsTransparent] = useState(
    !color ||
      color === "rgba(0,0,0,0)" ||
      color === "#000000" ||
      color.includes("transparent")
  );

  function handleFocus(text) {}

  function handleFocusOut(action, text) {
    if (!text.includes("#")) {
      text = "#" + text;
    }

    if (text.match(HEX_COLOR_REGEX)) {
      callback(action, text);
    }
  }

  const hexColor = convertColor(color || defaultTransparent, "hex");
  const hexColorCode = convertColor(colorCode || defaultTransparent, "hex");

  return display === "none" ? (
    <></>
  ) : (
    <Box className="tldr-color-picker" mr={0}>
      <Tooltip
        placement={props.isMobileView ? "top" : "bottom"}
        hasArrow
        label={!props.isMobileView && title}
      >
        <>
          {showIcon && (
            <StyledColorPickerIconButton
              showColorCode={!!hexColorCode}
              width={"32px"}
            >
              <Icon as={icon} />
            </StyledColorPickerIconButton>
          )}
          {showColorInput && (
            <StyledColorPickerIconButton
              showColorCode={!!hexColorCode}
              isIconDisplayed={showIcon}
              width={inputWidth}
            >
              <EditableLabel
                text={hexColorCode}
                labelClassName="colorcodename"
                inputClassName="colorcodeinput"
                onFocus={handleFocus}
                onFocusOut={(text) => handleFocusOut(action, text)}
                showIcon={false}
                inputMaxLength={7}
                labelPlaceHolder="try #f00"
              />
            </StyledColorPickerIconButton>
          )}
        </>
      </Tooltip>

      <Menu placement={props.isMobileView ? "top-end" : "auto"}
           isLazy>
        <MenuButton
          sx={
            isEmpty(menuButtonExtraStyling)
              ? menuButtonStyles
              : menuButtonExtraStyling
          }
          backgroundSize={"cover !important"}
          bg={hexColor}
          backgroundImage={
            (!color ||
              color.includes("transparent") ||
              color === "rgba(0,0,0,0)" ||
              color === "#000000") &&
            isTransparent
              ? `url(${transparentBg})`
              : null
          }
        >
          <StyledColorPickerPopover
            showBrandkitPaletteColors={showBrandkitPaletteColors}
          />
        </MenuButton>

        <MenuList
          sx={{
            border: "none",
            backgroundColor: "gray.500",
            padding: "0",
          }}
          h={props.isMobileView ? "55vh" : "100%"}
          overflow={"hidden auto"}
        >
          {showBrandkitPaletteColors && (
            <TldrBrandkitColors
              handleOnChangeComplete={({ rgb }) => {
                let bk = Format(
                  "rgba({},{},{},{})",
                  rgb.r,
                  rgb.g,
                  rgb.b,
                  rgb.a
                );
                callback(action, bk);
              }}
            />
          )}
          <SketchPicker
            disableAlpha={true}
            presetColors={DEFAULT_COLOR_PRESETS}
            color={hexColor}
            onChange={(e) => {
              e.hex === "transparent" || e.hex === "TRANSPARENT"
                ? setIsTransparent(true)
                : setIsTransparent(false);
              const bk = `rgba(${e.rgb.r},${e.rgb.g},${e.rgb.b},${e.rgb.a})`;
              callback(action, bk);
            }}
          />
          <EyeDropperContainer
            canvas={canvas}
            onChange={({ hex }) => {
              callback(action, convertColor(hex, "rgba"));
            }}
          />
        </MenuList>
      </Menu>
    </Box>
  );
};

TLDRColorPicker.propTypes = {
  callback: PropTypes.func.isRequired,
};

TLDRColorPicker.defaultProps = {
  title: "Color",
  icon: "palette",
  color: "transparent",
  property: "color",
  menuButtonExtraStyling: {},
};

const mapStateToProps = (state) => ({
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(TLDRColorPicker);
